<template>
  <div id="app" class="shane_tm_all_wrap">
    <router-view></router-view>
    <back-top color="#fff" :size="1.2" bottom="3%" :right="rightPosition" :slow="0"> </back-top>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    rightPosition() {
      let percentage = this.calculateDynamicPercentage(this.windowWidth);
      return percentage + '%';
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    calculateDynamicPercentage(width) {
      let percentage;
      if (width < 400) {
        percentage = 25;
      } else if (width >= 400 && width < 768) {
        percentage = -0.0521 * width + 44.0;
      } else if (width >= 768 && width < 1024) {
        percentage = -0.0078 * width + 18.0;
      } else if (width >= 1024 && width <= 1440) {
        percentage = -0.0052 * width + 14.0;
      } else {
        percentage = width > 1920 ? -0.0052 * 1920 + 14.0 : -0.0193 * width + 34.25;
      }
      return Math.max(0, percentage);
    },
    calculatePercentage(width) {
      let baseWidth = 1440;
      return (width / baseWidth) * 100;
    }
  },
  mounted() {
    document.body.classList.add("loaded");
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  destroyed() {
    document.body.classList.remove("loaded");
  },
};
</script>

<style lang="scss">
.back-top {
  z-index: 2147483647 !important;
}
.back-top__icon {
  color: #000 !important;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px !important;
  font-size: 20px !important;
}
#hubspot-messages-iframe-container {
  z-index: 2147483 !important;
}
</style>
